export default "__VITE_ASSET__BhkuZ0NS__"